import { Store } from "redux";
import configureStore from "./configureStore";

// Declare store as a local variable.
// It is generated by configureStore, which needs to build out discard and effect, but
// both of those need store to be available at run time, as does the peristCallback.
// As such - if you MUST use store directly, inject it where possible, or import the accessor
// getStore
// (At time of writing) the only places using store, via the getStore accessor are:
// discard
// effect
// persistCallback
// request.ts
// All of these receive the accessor via INJECTION - not via a direct import.

let store: Store<State>;

export function getStore(): Store<State> {
  return store;
}

export function createStore(onRehydrated): void {
  store = configureStore(onRehydrated, getStore);
}
